import React, { useState, useRef } from "react";
import {
    FaArrowLeft, FaShoppingCart, FaTrashAlt, FaShieldAlt,
    FaBolt, FaImage, FaTimesCircle, FaCheckCircle
} from "react-icons/fa";
import { myCustomTheme } from "../../Theme";
import "./style/CartWishlist.css";
const getDisplayPrice = (item) => {
    if (item.type === "Customize") {
        return Math.round(item.sellingPrice * 6 * 1.18);
    }
    return Math.round(item.sellingPrice * 1.18);
};
const getDisplayMrp = (item) => {
    if (item.type === "Customize") {
        return Math.round(item.mrp * 6 * 1.18);
    }
    return Math.round(item.mrp * 1.18);
};
/**
 * CartPage
 *
 * Props:
 *   cart               — array of product objects
 *   onBack             — go back
 *   onOpenProduct(item)— open product detail page
 *   onRemoveFromCart(id, e)
 *   onBuyAll(cart, cartImages) — all products checkout together
 */
const CartPage = ({ cart, onBack, onOpenProduct, onRemoveFromCart, onBuyAll }) => {
    const [cartImages, setCartImages] = useState({});
    const fileRefs = useRef({});
    const handleImageSelect = (productId, e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            setCartImages(prev => ({ ...prev, [productId]: reader.result }));
        };
        reader.readAsDataURL(file);
    };
    const handleRemoveImage = (productId, e) => {
        e.stopPropagation();
        setCartImages(prev => {
            const updated = { ...prev };
            delete updated[productId];
            return updated;
        });
        if (fileRefs.current[productId]) {
            fileRefs.current[productId].value = "";
        }
    };
    const cartTotal    = cart.reduce((sum, item) => sum + getDisplayPrice(item), 0);
    const cartMrpTotal = cart.reduce((sum, item) => sum + getDisplayMrp(item), 0);
    const totalSavings = cartMrpTotal - cartTotal;
    const customizeItemsMissingImage = cart.filter(
        item => item.type === "Customize" && !cartImages[item.id]
    );
    return (
        <div
            className="personal-view-page"
            style={{
                backgroundColor: myCustomTheme.colors.header_footer_bg,
                boxShadow: myCustomTheme.shadows.soft,
                borderRadius: "30px"
            }}
        >
            <button
                className="back-btn"
                onClick={onBack}
                style={{
                    backgroundColor: myCustomTheme.colors.button_bg,
                    color: myCustomTheme.colors.button_text
                }}
            >
                <FaArrowLeft /> Back to Products
            </button>
            <h1 className="view-title" style={{ color: myCustomTheme.colors.heading }}>
                My Cart ({cart.length} Item{cart.length !== 1 ? "s" : ""})
            </h1>
            {cart.length === 0 ? (
                <div className="empty-state-container">
                    <FaShoppingCart
                        className="empty-state-icon"
                        style={{ color: myCustomTheme.colors.bg_secondary }}
                    />
                    <p style={{ color: myCustomTheme.colors.menu_text }}>Your shopping cart is empty.</p>
                </div>
            ) : (
                <>
                    <div className="items-list-container">
                        {cart.map((item) => {
                            const sp       = getDisplayPrice(item);
                            const mrp      = getDisplayMrp(item);
                            const isCustom = item.type === "Customize";
                            const hasImage = Boolean(cartImages[item.id]);
                            return (
                                <div
                                    key={item.id}
                                    className="item-row-card"
                                    onClick={() => onOpenProduct(item)}
                                    style={{
                                        backgroundColor: myCustomTheme.colors.bg_primary,
                                        border: `1.5px solid ${isCustom && !hasImage
                                            ? "#fde68a"
                                            : myCustomTheme.colors.high_light}`,
                                        borderRadius: "20px",
                                        flexWrap: "wrap",
                                        gap: "12px"
                                    }}
                                >
                                    {/* ── Left: thumbnail + info ── */}
                                    <div style={{ display: "flex", gap: "14px", flex: 1, minWidth: "200px", alignItems: "flex-start" }}>
                                        <img
                                            src={item.images && item.images[0]}
                                            alt=""
                                            className="item-row-thumb"
                                            style={{ borderRadius: "12px", objectFit: "cover", flexShrink: 0 }}
                                        />
                                        <div className="item-row-info" style={{ flex: 1 }}>
                                            <h3 style={{ color: myCustomTheme.colors.heading, marginBottom: "4px" }}>
                                                {item.name}
                                            </h3>
                                            <p className="item-row-price" style={{ color: myCustomTheme.colors.heading, margin: "0 0 2px 0" }}>
                                                ₹{sp}{" "}
                                                {mrp > sp && (
                                                    <span style={{
                                                        color: myCustomTheme.colors.menu_text,
                                                        textDecoration: "line-through",
                                                        fontSize: "12px"
                                                    }}>
                                                        ₹{mrp}
                                                    </span>
                                                )}
                                            </p>
                                            <p style={{
                                                fontSize: "10px", color: "#15803d", fontWeight: "600",
                                                margin: "0 0 6px 0", display: "flex", alignItems: "center", gap: "3px"
                                            }}>
                                                <FaShieldAlt style={{ fontSize: "9px" }} />
                                                18% GST included{isCustom && " · 6\" default"}
                                            </p>
                                            {/* ── Image upload for Customize products ── */}
                                            {isCustom && (
                                                <div
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={{ marginTop: "4px" }}
                                                >
                                                    {hasImage ? (
                                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                            <div style={{ position: "relative", display: "inline-block" }}>
                                                                <img
                                                                    src={cartImages[item.id]}
                                                                    alt="Design"
                                                                    style={{
                                                                        width: "54px", height: "54px",
                                                                        objectFit: "cover", borderRadius: "10px",
                                                                        border: "2px solid #fcd34d"
                                                                    }}
                                                                />
                                                                <button
                                                                    onClick={(e) => handleRemoveImage(item.id, e)}
                                                                    style={{
                                                                        position: "absolute", top: "-7px", right: "-7px",
                                                                        background: "none", border: "none",
                                                                        cursor: "pointer", padding: 0,
                                                                        color: "#ef4444", fontSize: "16px"
                                                                    }}
                                                                >
                                                                    <FaTimesCircle />
                                                                </button>
                                                            </div>
                                                            <div>
                                                                <p style={{ margin: 0, fontSize: "11px", fontWeight: "700", color: "#15803d", display: "flex", alignItems: "center", gap: "4px" }}>
                                                                    <FaCheckCircle style={{ fontSize: "10px" }} /> Design Added
                                                                </p>
                                                                <button
                                                                    onClick={() => fileRefs.current[item.id]?.click()}
                                                                    style={{
                                                                        marginTop: "4px", background: "none",
                                                                        border: "none", cursor: "pointer",
                                                                        fontSize: "11px", color: "#3b82f6",
                                                                        padding: 0, fontWeight: "600"
                                                                    }}
                                                                >
                                                                    Change image
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <button
                                                            onClick={() => fileRefs.current[item.id]?.click()}
                                                            style={{
                                                                display: "flex", alignItems: "center", gap: "6px",
                                                                padding: "7px 12px",
                                                                background: "#fffbeb",
                                                                border: "1.5px dashed #fcd34d",
                                                                borderRadius: "8px",
                                                                cursor: "pointer",
                                                                fontSize: "12px", fontWeight: "600", color: "#92400e"
                                                            }}
                                                        >
                                                            <FaImage style={{ fontSize: "13px", color: "#d97706" }} />
                                                            Upload Design Image *
                                                        </button>
                                                    )}
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        style={{ display: "none" }}
                                                        ref={(el) => { fileRefs.current[item.id] = el; }}
                                                        onChange={(e) => handleImageSelect(item.id, e)}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {/* ── Right: only delete button (no individual Order Now) ── */}
                                    <div className="item-row-actions" onClick={(e) => e.stopPropagation()}>
                                        <button
                                            className="row-action-btn delete"
                                            onClick={(e) => onRemoveFromCart(item.id, e)}
                                            style={{
                                                backgroundColor: myCustomTheme.colors.bg_secondary,
                                                color: "#ef4444"
                                            }}
                                        >
                                            <FaTrashAlt />
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    {/* ── Cart Summary + Buy All ── */}
                    <div style={{
                        marginTop: "20px",
                        borderRadius: "20px",
                        border: `1.5px solid ${myCustomTheme.colors.high_light}`,
                        overflow: "hidden",
                        backgroundColor: myCustomTheme.colors.bg_primary
                    }}>
                        {totalSavings > 0 && (
                            <div style={{
                                background: "#f0fdf4",
                                borderBottom: "1.5px solid #86efac",
                                padding: "10px 20px",
                                fontSize: "13px", fontWeight: "700", color: "#15803d",
                                display: "flex", alignItems: "center", gap: "6px"
                            }}>
                                <FaShieldAlt style={{ fontSize: "12px" }} />
                                You save ₹{totalSavings} on this cart!
                            </div>
                        )}
                        {customizeItemsMissingImage.length > 0 && (
                            <div style={{
                                background: "#fffbeb",
                                borderBottom: "1.5px solid #fde68a",
                                padding: "10px 20px",
                                fontSize: "12px", fontWeight: "600", color: "#92400e",
                                display: "flex", alignItems: "center", gap: "6px"
                            }}>
                                <FaImage style={{ fontSize: "12px", color: "#d97706" }} />
                                {customizeItemsMissingImage.length === 1
                                    ? `Please upload a design image for "${customizeItemsMissingImage[0].name}" before buying all.`
                                    : `${customizeItemsMissingImage.length} customized products need design images before buying all.`}
                            </div>
                        )}
                        <div style={{ padding: "18px 20px" }}>
                            <div style={{ marginBottom: "14px" }}>
                                {cart.map((item) => (
                                    <div key={item.id} style={{
                                        display: "flex", justifyContent: "space-between",
                                        padding: "7px 0",
                                        borderBottom: `1px solid ${myCustomTheme.colors.high_light}`,
                                        fontSize: "13px", alignItems: "center"
                                    }}>
                                        <span style={{ color: myCustomTheme.colors.menu_text, flex: 1, marginRight: "10px" }}>
                                            {item.name}
                                            {item.type === "Customize" && (
                                                <span style={{ fontSize: "11px", color: "#94a3b8" }}> (6")</span>
                                            )}
                                            {item.type === "Customize" && cartImages[item.id] && (
                                                <span style={{
                                                    marginLeft: "6px", fontSize: "10px",
                                                    color: "#15803d", fontWeight: "700",
                                                    display: "inline-flex", alignItems: "center", gap: "3px"
                                                }}>
                                                    <FaCheckCircle style={{ fontSize: "9px" }} /> Design ready
                                                </span>
                                            )}
                                        </span>
                                        <span style={{ fontWeight: "700", color: myCustomTheme.colors.heading, whiteSpace: "nowrap" }}>
                                            ₹{getDisplayPrice(item)}
                                        </span>
                                    </div>
                                ))}
                            </div>
                            <div style={{
                                fontSize: "11px", color: "#15803d", fontWeight: "600",
                                marginBottom: "14px", display: "flex", alignItems: "center", gap: "6px"
                            }}>
                                <FaShieldAlt style={{ fontSize: "10px" }} />
                                All prices include 18% GST · Shipping calculated at checkout
                            </div>
                            <div style={{
                                display: "flex", justifyContent: "space-between",
                                alignItems: "center",
                                paddingTop: "12px",
                                borderTop: `2px solid ${myCustomTheme.colors.high_light}`
                            }}>
                                <div>
                                    <p style={{ margin: 0, fontSize: "13px", color: myCustomTheme.colors.menu_text }}>
                                        {cart.length} item{cart.length !== 1 ? "s" : ""} subtotal
                                    </p>
                                    <p style={{ margin: "2px 0 0 0", fontSize: "22px", fontWeight: "800", color: myCustomTheme.colors.heading }}>
                                        ₹{cartTotal}
                                    </p>
                                    <p style={{ margin: "2px 0 0 0", fontSize: "11px", color: "#64748b" }}>
                                        + shipping at checkout
                                    </p>
                                </div>
                                <button
                                    onClick={() => onBuyAll && onBuyAll(cart, cartImages)}
                                    disabled={customizeItemsMissingImage.length > 0}
                                    style={{
                                        padding: "14px 22px",
                                        backgroundColor: customizeItemsMissingImage.length > 0
                                            ? "#94a3b8"
                                            : myCustomTheme.colors.button_bg,
                                        color: myCustomTheme.colors.button_text,
                                        border: "none",
                                        borderRadius: "14px",
                                        fontSize: "14px",
                                        fontWeight: "700",
                                        cursor: customizeItemsMissingImage.length > 0 ? "not-allowed" : "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        flexShrink: 0
                                    }}
                                    title={customizeItemsMissingImage.length > 0
                                        ? "Upload design images for all customized products first"
                                        : `Buy all ${cart.length} items`}
                                >
                                    <FaBolt style={{ fontSize: "13px" }} />
                                    Buy All ({cart.length})
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
export default CartPage;